import { LockIcon } from "@phosphor-icons/react/dist/csr/Lock";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { PacksHeaderActions, usePacksSection } from "./packs-section";
import { summarizePackApprovals } from "./utils";

export const RecipientsHeader = ({ embedded }: { embedded: boolean }) => {
  const { previewOnly, filteredRecipients, technicianSearch } =
    usePacksSection();

  const approvals = summarizePackApprovals(filteredRecipients);
  const showApprovals =
    !previewOnly &&
    approvals.approved + approvals.stale + approvals.unknown > 0;

  return (
    <Stack
      direction="row"
      align="center"
      justify="between"
      gap={4}
      className="w-full shrink-0 flex-wrap gap-y-3 border-b px-4 py-3"
    >
      <Stack align="start" gap={1} className="min-w-0">
        <Stack direction="row" align="center" gap={1}>
          {previewOnly && (
            <LockIcon className="size-3.5 shrink-0 text-subtle" aria-hidden />
          )}
          <Text variant="caption" tone="muted">
            {previewOnly
              ? "PayPack emails aren't set up for this business."
              : `${filteredRecipients.length} recipient${filteredRecipients.length === 1 ? "" : "s"}`}
            {showApprovals && (
              <>
                {` · ${approvals.approved} approved`}
                {approvals.stale > 0 &&
                  `, ${approvals.stale} before the figures changed`}
                {approvals.unknown > 0 && `, ${approvals.unknown} unverified`}
              </>
            )}
          </Text>
        </Stack>
        <Text variant="caption" tone="muted">
          {technicianSearch.trim() &&
            `${filteredRecipients.length} search match${filteredRecipients.length === 1 ? "" : "es"}. `}
          Click a recipient to view their PayPack.
        </Text>
      </Stack>
      {!embedded && <PacksHeaderActions />}
    </Stack>
  );
};
